import { render, staticRenderFns } from "./AgentDiffCard.vue?vue&type=template&id=08b43ea2&scoped=true&"
import script from "./AgentDiffCard.vue?vue&type=script&lang=js&"
export * from "./AgentDiffCard.vue?vue&type=script&lang=js&"
import style0 from "./AgentDiffCard.vue?vue&type=style&index=0&id=08b43ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b43ea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VCard,VCardText,VChip})
